var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { atom } from 'jotai';
import DashboardAPI from '../API/DashboardAPI';
import AnalyticsUniqueCustomers from '../Models/Dashboard/Reporting/AnalyticsUniqueCustomers';
import AnalyticsAverageOrderProductQuantity from '../Models/Dashboard/Reporting/AnalyticsAverageOrderProductQuantity';
import { atomWithStorage, createJSONStorage } from 'jotai/utils';
import AverageOrderValue from '../Models/Dashboard/Reporting/AverageOrderValue';
export var AnalyticsStartDateAtom = atom(new Date());
export var AnalyticsEndDateAtom = atom(new Date());
export var TopSellingProductListAtom = atom([]);
export var AnalyticsPageMetricsAtom = atom({});
export var AnalyticsOrderDataAtom = atom({});
export var AnalyticsUserDataAtom = atom({});
export var AverageOrderValueAtom = atom(new AverageOrderValue());
export var AnalyticsLoggedInCustomersAtom = atom(new AnalyticsUniqueCustomers());
export var AnalyticsAvgOrderProductQuantityAtom = atom(new AnalyticsAverageOrderProductQuantity());
var analyticsSessionStorage = __assign(__assign({}, createJSONStorage(function () { return sessionStorage; })), { delayInit: false });
export var AnalyticsIdAtom = atomWithStorage('sessionId', "", analyticsSessionStorage);
export var AnalyticsUserProxyAtom = atomWithStorage('userProxy', "");
export var FetchAnalyticsOrderDataAtom = atom(function (get) {
    return get(AnalyticsOrderDataAtom);
}, function (get, set) { return __awaiter(void 0, void 0, void 0, function () {
    var mutate, start, end, res, e_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                mutate = get(AnalyticsOrderDataAtom);
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                start = get(AnalyticsStartDateAtom);
                end = get(AnalyticsEndDateAtom);
                return [4 /*yield*/, DashboardAPI.getAnalyticsOrderData(null, start, end)];
            case 2:
                res = _a.sent();
                set(AnalyticsOrderDataAtom, res.data);
                return [3 /*break*/, 4];
            case 3:
                e_1 = _a.sent();
                console.error('[FetchAnalyticsOrderDataAtom] Could not fetch data: ' + e_1.message, e_1);
                throw e_1;
            case 4: return [2 /*return*/];
        }
    });
}); });
export var FetchAnalyticsUserDataAtom = atom(function (get) {
    return get(AnalyticsUserDataAtom);
}, function (get, set) { return __awaiter(void 0, void 0, void 0, function () {
    var mutate, start, end, res, e_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                mutate = get(AnalyticsUserDataAtom);
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                start = get(AnalyticsStartDateAtom);
                end = get(AnalyticsEndDateAtom);
                return [4 /*yield*/, DashboardAPI.getAnalyticsUserData(null, start, end)];
            case 2:
                res = _a.sent();
                //console.error(res.data);
                set(AnalyticsUserDataAtom, res.data);
                return [3 /*break*/, 4];
            case 3:
                e_2 = _a.sent();
                console.error('[FetchAnalyticsUserDataAtom] Could not fetch data: ' + e_2.message, e_2);
                throw e_2;
            case 4: return [2 /*return*/];
        }
    });
}); });
export var FetchTopSellingProductsAtom = atom(function (get) {
    return get(TopSellingProductListAtom);
}, function (get, set) { return __awaiter(void 0, void 0, void 0, function () {
    var mutate, start, end, res, e_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                mutate = get(TopSellingProductListAtom);
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                start = get(AnalyticsStartDateAtom);
                end = get(AnalyticsEndDateAtom);
                return [4 /*yield*/, DashboardAPI.getTopSellingProducts(null, start, end, "500")];
            case 2:
                res = _a.sent();
                set(TopSellingProductListAtom, res.response.products);
                return [3 /*break*/, 4];
            case 3:
                e_3 = _a.sent();
                console.error('[FetchAnalyticsUserDataAtom] Could not fetch data: ' + e_3.message, e_3);
                throw e_3;
            case 4: return [2 /*return*/];
        }
    });
}); });
export var FetchAnalyticsLoggedInCustomersAtom = atom(function (get) {
    return get(AnalyticsLoggedInCustomersAtom);
}, function (get, set) { return __awaiter(void 0, void 0, void 0, function () {
    var mutate, start, end, res, e_4;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                mutate = get(AnalyticsLoggedInCustomersAtom);
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                start = get(AnalyticsStartDateAtom);
                end = get(AnalyticsEndDateAtom);
                return [4 /*yield*/, DashboardAPI.getUniqueLoggedInCustomers(null, start, end)];
            case 2:
                res = _a.sent();
                set(AnalyticsLoggedInCustomersAtom, res.response);
                return [3 /*break*/, 4];
            case 3:
                e_4 = _a.sent();
                console.error('[FetchAnalyticsLoggedInCustomersAtom] Could not fetch data: ' + e_4.message, e_4);
                throw e_4;
            case 4: return [2 /*return*/];
        }
    });
}); });
export var FetchAnalyticsAvgOrderProductQuantity = atom(function (get) {
    return get(AnalyticsAvgOrderProductQuantityAtom);
}, function (get, set) { return __awaiter(void 0, void 0, void 0, function () {
    var mutate, start, end, res, e_5;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                mutate = get(AnalyticsAvgOrderProductQuantityAtom);
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                start = get(AnalyticsStartDateAtom);
                end = get(AnalyticsEndDateAtom);
                return [4 /*yield*/, DashboardAPI.getAverageOrderProductQuantity(null, start, end)];
            case 2:
                res = _a.sent();
                set(AnalyticsAvgOrderProductQuantityAtom, res.response);
                return [3 /*break*/, 4];
            case 3:
                e_5 = _a.sent();
                console.error('[FetchAnalyticsAvgOrderProductQuantity] Could not fetch data: ' + e_5.message, e_5);
                throw e_5;
            case 4: return [2 /*return*/];
        }
    });
}); });
export var FetchAverageOrderValueAtom = atom(function (get) {
    return get(AverageOrderValueAtom);
}, function (get, set) { return __awaiter(void 0, void 0, void 0, function () {
    var mutate, start, end, res, e_6;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                mutate = get(AverageOrderValueAtom);
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                start = get(AnalyticsStartDateAtom);
                end = get(AnalyticsEndDateAtom);
                return [4 /*yield*/, DashboardAPI.getAverageOrderValue(null, start, end)];
            case 2:
                res = _a.sent();
                set(AverageOrderValueAtom, res.response);
                return [3 /*break*/, 4];
            case 3:
                e_6 = _a.sent();
                console.error('[FetchAverageOrderValueAtom] Could not fetch data: ' + e_6.message, e_6);
                throw e_6;
            case 4: return [2 /*return*/];
        }
    });
}); });
export var FetchAnalyticsPageMetricsAtom = atom(function (get) {
    return get(AnalyticsPageMetricsAtom);
}, function (get, set) { return __awaiter(void 0, void 0, void 0, function () {
    var mutate, start, end, res, e_7;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                mutate = get(AnalyticsPageMetricsAtom);
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                start = get(AnalyticsStartDateAtom);
                end = get(AnalyticsEndDateAtom);
                return [4 /*yield*/, DashboardAPI.getAnalyticsPageMetrics(null, start, end)];
            case 2:
                res = _a.sent();
                set(AnalyticsPageMetricsAtom, res);
                return [3 /*break*/, 4];
            case 3:
                e_7 = _a.sent();
                console.error('[FetchAnalyticsPageMetricsAtom] Could not fetch data: ' + e_7.message, e_7);
                throw e_7;
            case 4: return [2 /*return*/];
        }
    });
}); });
